import React from 'react';
import { Col } from 'react-bootstrap';

// note: changed defaultChecked to checked - regression test
export function renderOptionsField(field)
{
	//const fieldValue = isEmpty(field.meta.initial) === false ? field.meta.initial: field.defaultvalue;
	const fieldValue = field.input.value;
	const colWidth = field.colWidth ? field.colWidth : 'col-sm-10'
	return (
		<div className={`form-group ${colWidth}`}>
			<label className={field.labelattrs}>{field.label}</label>
			<Col  className={field.inputattrs}>
				{ 
					field.values.map(function(fld,index) {
                        const color = fld.color !== undefined ? fld.color:'black';
						return ( 
							<label key={index *5} className="radio-inline c-radio" style={{ color }}>
								<input {...field.input} type="radio" key={index * 6} name={field.id} id={field.id} value={fld.abbreviation}  
									checked={(fieldValue === fld.abbreviation) || fieldValue === field.selected}
									disabled={field.disabled}
								/>
									<em className="fa fa-circle" />&nbsp;&nbsp;{fld.name}
							</label> 
						)
					})
				}
			</Col>
		</div>
	)
}


// WEBPACK FOOTER //
// ./src/modules/components/fieldoptioncomponent.js